export default [
  {
    path: '/all-customer',
    name: 'all-customer',
    component: resolve => require(['views/all-customer'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/customer-of-gene',
    name: 'customer-of-gene',
    component: resolve => require(['views/all-customer'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/customer-of-adult-cells',
    name: 'customer-of-adult-cells',
    component: resolve => require(['views/all-customer'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/customer-of-neonate',
    name: 'customer-of-neonate',
    component: resolve => require(['views/all-customer'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/online-customer',
    name: 'online-customer',
    component: resolve => require(['views/all-customer'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/all-customer/customer-detail/:id',
    name: 'customer-detail',
    props: true,
    component: resolve => require(['views/customer-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '全部用户/用户详情' }
  },
  {
    path: '/all-customer/health-record-detail/:id',
    props: true,
    name: 'health-record-detail',
    component: resolve => require(['views/health-record-detail'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/roles-permissions',
    props: true,
    name: 'user-roles',
    component: resolve => require(['views/user-roles'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/roles-permissions/roles-form/:isEdit/:id',
    name: 'roles-form',
    props: true,
    component: resolve => require(['views/roles-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '用户权限/角色', isForm: true }
  },
  {
    path: '/customer-of-system',
    name: 'customer-of-system',
    component: resolve => require(['views/customer-of-system'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/customer-of-system/system-customer-form/:isEdit/:userLogin',
    props: true,
    name: 'system-customer-form',
    component: resolve => require(['views/system-customer-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '系统用户/用户', isForm: true }
  },
  {
    path: '/export-history/customer-list',
    props: true,
    name: 'export-history-customer',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '全部用户/生命银行用户导出历史' }
  }
]
